import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isObject from '@cotyorg/ccx-utils/js/helpers/isObject';
import NavigationLinks from '@cotyorg/ccx-molecules/NavigationLinks';
import Picture from '@cotyorg/ccx-atoms/Picture';
import ShowHide from '@cotyorg/ccx-utils/js/components/ShowHide';

const NavigationVerticalList = ({
  navigation,
  isVisible,
  imageSrc,
  alt = '',
  imageSrcset,
  noOfColumns,
}) => {
  const className = classNames(
    'navigation',
    'navigation-vertical-list', {
      'navigation-vertical-list--is-visible': isVisible,
    },
  );

  if (!isObject(navigation) || !Array.isArray(navigation.pages)) {
    return null;
  }

  const { pages } = navigation;

  return (
    <ShowHide
      isOpen={isVisible}
      noTransitionClass="navigation-vertical-list--no-transition"
      extraClass={className}
    >
      <nav>
        <div className="navigation-vertical-list__container">
          <div className="grid-container">
            <ul className="navigation__list grid-x">
              <NavigationLinks
                pages={pages}
                selectedSlug={navigation.selectedSlug}
                extraClass="cell auto"
              />
              {
                // Show an image in the right-most column if the current number of columns
                // is less than the max and if an image source has been provided.
                pages.length < noOfColumns && imageSrc && (
                  <li className="cell auto navigation__list-item--vertical">
                    <Picture
                      src={imageSrc}
                      alt={alt}
                      srcset={imageSrcset}
                      extraClass="navigation-vertical-list__picture"
                      doNotLazyLoad
                    />
                  </li>
                )
              }
            </ul>
          </div>
        </div>
      </nav>
    </ShowHide>
  );
};

NavigationVerticalList.defaultProps = {
  noOfColumns: 5,
};

NavigationVerticalList.propTypes = {
  navigation: PropTypes.shape({
    pages: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      pages: PropTypes.array,
      openInNewWindow: PropTypes.bool,
    })),
  }),
  isVisible: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string,
  alt: PropTypes.string,
  imageSrcset: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  noOfColumns: PropTypes.number,
};

export default NavigationVerticalList;
